import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers';
import { useAuth } from '@clerk/clerk-react';
import { GET_LIVE_CONTEXT_STATE_QUERY_KEY } from '@/state/queries/player/use-get-live-context-state';
import { GET_LIVE_LANGUAGE_STATUS_QUERY_KEY } from '@/state/queries/player/use-live-language-status';

export type UpdateLiveLanguageRequest = {
  entityRef: string;
  enabled?: boolean;
  captions?: { stagePlayer?: boolean; roomPlayer?: boolean; onlinePlayer?: boolean };
  showLanguageMarker?: boolean;
};

export const useUpdateLiveLanguageMutation = () => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: UpdateLiveLanguageRequest) => {
      const token = await getToken();
      const url = `${import.meta.env.VITE_API_URL}/player/live-context-state/live-language`;
      return sendJSONRequest({ url, method: METHOD.POST, body, token: token ?? '' });
    },
    onSuccess: (_, variables) => {
      void queryClient.invalidateQueries({ queryKey: [GET_LIVE_LANGUAGE_STATUS_QUERY_KEY, variables.entityRef] });
      void queryClient.invalidateQueries({ queryKey: [GET_LIVE_CONTEXT_STATE_QUERY_KEY, variables.entityRef] });
    },
  });
};
